import Icon from "assets/icons";
import { orderBy } from "lodash";
import React from "react";
import NoDataFound from "shared/components/noDataFound";
import Button from "../../../../shared/components/button";
import { Modal, ModalBody, ModalHeader } from "../../../../shared/components/modal";
import Size from "../../../../shared/enums/Size";
import Variant from "../../../../shared/enums/Variant";
import { useCopies } from "../../../../shared/hooks/useCopies";
import useNavigateWrapper from "../../../../shared/hooks/useNavigateWrapper";
import PurchaseOrderCard from "./components/purchaseOrderCard";
import usePurchaseHistoryService from "./service";

export default function PurchaseHistory() {
  const copies = useCopies();
  const service = usePurchaseHistoryService();
  const { navigateToPreviousPath } = useNavigateWrapper();
  return (
    <React.Fragment>
      <Modal size={Size.LARGE}>
        <ModalHeader
          left={copies.get("purchase.history")}
          right={
            service.purchaseHistoryList.length > 1 && (
              <Button
                variant={Variant.LINK}
                icon={<Icon.Send />}
                label={copies.get("purchase.history.send.all.invoices")}
                onClick={service.sendAllInvoicesHandler}
              />
            )
          }
          onClose={() => navigateToPreviousPath()}
        />
        <ModalBody>
          {orderBy(service.purchaseHistoryList, "createdDate.dateTime", "desc").map((purchaseOrder, index) => (
            <PurchaseOrderCard key={index} purchaseOrder={purchaseOrder} />
          ))}
          {service.purchaseHistoryList.length === 0 && (
            <div className="noPurchaseHistory">
              <NoDataFound
                label={copies.get("purchase.history.not.available")}
                icon={<Icon.ReceiptNew />}
                height="40vh"
              />
            </div>
          )}
        </ModalBody>
      </Modal>
    </React.Fragment>
  );
}
